import { render, staticRenderFns } from "./AlertBox.vue?vue&type=template&id=59c036d4&scoped=true&"
import script from "./AlertBox.vue?vue&type=script&lang=js&"
export * from "./AlertBox.vue?vue&type=script&lang=js&"
import style0 from "./AlertBox.vue?vue&type=style&index=0&id=59c036d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c036d4",
  null
  
)

export default component.exports